import { useEffect, useState } from "react";
import { DIALOG_TRANSITION_MS } from "../dialogTransition";

/**
 * For a dialog that is mounted only while it is open (`{isOpen && <SomeDialog … />}`, to
 * skip its requests until it is needed): true while it is open and for the closing
 * animation after it, so the dialog animates out instead of vanishing.
 */
export const useStaysMountedToClose = (open: boolean): boolean => {
  const [closing, setClosing] = useState(false);
  const [wasOpen, setWasOpen] = useState(open);

  if (open && !wasOpen) setWasOpen(true);
  if (!open && wasOpen) {
    setWasOpen(false);
    setClosing(true);
  }

  useEffect(() => {
    if (!closing) return;
    const timer = setTimeout(() => setClosing(false), DIALOG_TRANSITION_MS);
    return () => clearTimeout(timer);
  }, [closing]);

  return open || closing;
};
